import React from 'react';
import PropTypes from 'prop-types';
import enhance from './Profile.enhancer';
import CompanyProfile from '../company/profile/CompanyProfile';
import InfluencerProfileContainer from '../influencer/profile/InfluencerProfileContainer';
import Typography from '@material-ui/core/Typography';

class Profile extends React.Component {
  constructor() {
    super();

    this.state = {
      profileToView: {},
      userId: ''
    };
  }

  componentDidMount() {
    this.loadData(this.props.userId);
  }

  componentWillReceiveProps(nextProps) {
    const currentUid = this.props.match.params.uid;
    const nextuid = nextProps.match.params.uid;

    if (currentUid !== nextuid) {
      this.loadData(nextuid);
    }
  }

  loadData(userId) {
    this.props.firestore
      .get({
        collection: 'users',
        doc: userId
      })
      .then(user => {
        const userData = user.data();
        if (userData) {
          this.setState({
            userId,
            profileToView: { ...userData, id: userId }
          });
        }
      })
      .catch(err => {});
  }

  render() {
    // const { userId } = this.props;
    const { profile, auth, classes } = this.props;
    const { profileToView, userId } = this.state;

    return (
      <React.Fragment id="profile-container">
        {profileToView &&
          userId &&
          profileToView.isCompany &&
          (!profile.isCompany || auth.uid === userId) && (
            <CompanyProfile userId={userId} />
          )}
        {profileToView &&
          userId &&
          profileToView.isCompany &&
          (profile.isCompany && auth.uid !== userId) && (
            <Typography
              align="center"
              justify="center"
              variant="h3"
              className={classes.cannotView}
            >
              Cannot view company's profile
            </Typography>
          )}
        {profileToView &&
          userId &&
          !profileToView.isCompany &&
          (profile.isCompany || auth.uid === userId) && (
            // <InfluencerProfile userId={userId} />
            <InfluencerProfileContainer userId={userId} user={profileToView} />
          )}
        {profileToView &&
          userId &&
          !profileToView.isCompany &&
          !profile.isCompany &&
          auth.uid !== userId && (
            <Typography
              align="center"
              justify="center"
              variant="h3"
              className={classes.cannotView}
            >
              Cannot view influencer's profile
            </Typography>
          )}
      </React.Fragment>
    );
  }
}

export default enhance(Profile);



// WEBPACK FOOTER //
// ./src/components/profile/Profile.js